import React from "react";
import { Box } from "@mui/material";
import PageTitle from "../../../common/PageTitle";
import withLayout from "../../../hocs/Layout";
import TrackBox from "../../tracking/list/trackBox";
import { pageContainerSx } from '../../../styles/patterns';

export const BulkTracking = () => {
    return (
        <Box sx={pageContainerSx}>
            <PageTitle subTitle="Track multiple shipments at once by entering AWB numbers or uploading a file">Bulk Shipment Tracking</PageTitle>
            <TrackBox />
        </Box>
    )
}

export default withLayout(BulkTracking);
